var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditActionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15.625px",
    height: "15.625px",
    viewBox: "0 0 15.625 15.625",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "63BFC70A-8F2F-41E6-B9A1-5436242CA6BF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prospecting",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prospect-Details--Sales-Plan",
    transform: "translate(-225.4211, -475.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(225.4211, 475.336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.671875,6.8359375 L13.671875,12.6953125 C13.671875,13.233429 13.235321,13.671875 12.6953125,13.671875 L2.9296875,13.671875 C2.39157104,13.671875 1.953125,13.233429 1.953125,12.6953125 L1.953125,1.953125 L8.7890625,1.953125 L10.7421875,0 L1.953125,0 C0.875,0 0,0.875 0,1.953125 L0,12.6953125 C0,14.313446 1.3125,15.625 2.9296875,15.625 L12.6953125,15.625 C14.3143616,15.625 15.625,14.313446 15.625,12.6953125 L15.625,4.8828125 L13.671875,6.8359375 Z",
    id: "Path",
    fill: "#38517B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.671875,6.8359375 L13.671875,12.6953125 C13.671875,13.233429 13.235321,13.671875 12.6953125,13.671875 L2.9296875,13.671875 C2.39157104,13.671875 1.953125,13.233429 1.953125,12.6953125 L1.953125,1.953125 L8.7890625,1.953125 L10.7421875,0 L1.953125,0 C0.875,0 0,0.875 0,1.953125 L0,12.6953125 C0,14.313446 1.3125,15.625 2.9296875,15.625 L12.6953125,15.625 C14.3143616,15.625 15.625,14.313446 15.625,12.6953125 L15.625,4.8828125 L13.671875,6.8359375 Z",
    id: "Path",
    fill: "#38517B",
    fillRule: "nonzero",
    transform: "translate(7.8125, 7.8125) scale(-1, 1) translate(-7.8125, -7.8125)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "+",
    transform: "translate(4.1577, 3.9307)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "+",
    fill: "#38517B",
    fillRule: "nonzero",
    points: "8.82324219 6.79443359 11.4672852 6.79443359 11.4672852 8.70605469 8.82324219 8.70605469 8.82324219 11.6943359 6.80908203 11.6943359 6.80908203 8.70605469 4.15771484 8.70605469 4.15771484 6.79443359 6.80908203 6.79443359 6.80908203 3.93066406 8.82324219 3.93066406"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditActionIcon);
export default __webpack_public_path__ + "static/media/edit-action-icon.baf7b97d3b5350483acbfc5a46d6d7dd.svg";
export { ForwardRef as ReactComponent };